'use client';

import { useEffect, useState } from 'react';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      if (typeof window === 'undefined') return;
      setIsMobile(window.matchMedia('(max-width: 767px)').matches);
    };

    checkMobile();

    const mediaQuery = window.matchMedia('(max-width: 767px)');
    mediaQuery.addEventListener('change', checkMobile);
    window.addEventListener('resize', checkMobile);

    return () => {
      mediaQuery.removeEventListener('change', checkMobile);
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  return isMobile;
};
